// extracted by mini-css-extract-plugin
export default {"info":"OverquotaRestoreRequestedInfo__info--1uY6q","infoIcon":"OverquotaRestoreRequestedInfo__infoIcon--wttAb"};